var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-right_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M49.294 21.782 59.51 32 39.046 52.465l-4.27-4.27L47.981 34.99H3.666V29.01h44.316L34.775 15.804l2.12-2.12c1.167-1.165 2.134-2.12 2.15-2.12s4.629 4.599 10.249 10.218",
    clipRule: "evenodd"
  })));
};
export { SvgArrowRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQ5LjI5MzUgMjEuNzgyNEw1OS41MTEgMzJMMzkuMDQ1OCA1Mi40NjUxTDM0Ljc3NTMgNDguMTk1OUw0Ny45ODE4IDM0Ljk4ODlIMy42NjU1M1YyOS4wMTA5SDQ3Ljk4MThMMzQuNzc1MyAxNS44MDRMMzYuODk1NSAxMy42ODQ0QzM4LjA2MTYgMTIuNTE4NyAzOS4wMjkzIDExLjU2NDkgMzkuMDQ1OSAxMS41NjQ5QzM5LjA2MjUgMTEuNTY0OSA0My42NzQgMTYuMTYyOCA0OS4yOTM1IDIxLjc4MjRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";